<ng-container *ngIf="$imgSrc | async as src">
  <img [lazyLoad]="src" [defaultImage]="defaultImg" [alt]="imgAlt" />
</ng-container>
